import { faChevronDown } from '@fortawesome/pro-solid-svg-icons';
import classNames from 'classnames';
import { useEffect, useState } from 'react';
import { useRefinementList } from 'react-instantsearch';
import styled from 'styled-components';

import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { VerticalDivider } from '@sorare/core/src/atoms/ui/Divider';
import { useIntlContext } from '@sorare/core/src/contexts/intl';
import useScreenSize from '@sorare/core/src/hooks/device/useScreenSize';

import { ButtonLabel, StyledDropdown, StyledDropdownOptionLabel } from '../ui';

const StyledDivider = styled(VerticalDivider)`
  background-color: var(--c-neutral-400);
  height: var(--quadruple-unit);
`;

type Props = {
  isNationalTeam: boolean;
};
export const TeamFilters = ({ isNationalTeam }: Props) => {
  const { up: isTablet } = useScreenSize('tablet');
  const { formatMessage } = useIntlContext();
  const { items, refine: doRefine } = useRefinementList({
    attribute: isNationalTeam ? 'active_national_team.long_name' : 'team.name',
    limit: 40,
  });

  const defaultOption = {
    label: formatMessage({
      id: 'primaryBuyModalGrid.teamFilters.allPlayers',
      defaultMessage: 'All players',
    }),
    value: 'all',
  };
  const [selected, setSelected] = useState<{ value: string; label: string }>(
    defaultOption
  );
  const [orderedItems, setOrderedItems] = useState<string[] | null>(null);

  useEffect(() => {
    if (items.length && !orderedItems) {
      setOrderedItems(items.map(i => i.value));
    }
  }, [items, orderedItems]);

  if (!orderedItems || orderedItems.length < 2) return null;

  const options = [
    defaultOption,
    ...orderedItems.map(value => ({
      label: value,
      value,
    })),
  ];
  const cleanRefinement = () => {
    items.map(item => item.isRefined && doRefine(item.value));
  };

  const onChange = (value: string) => {
    setSelected(options.find(o => o.value === value) || defaultOption);
    cleanRefinement();
    if (value !== 'all') doRefine(value);
  };
  return (
    <>
      <StyledDropdown
        closeOnChange
        fullWidth={!isTablet}
        label={props => (
          <Button
            {...props}
            color="tertiary"
            size="medium"
            fullWidth={!isTablet}
          >
            <ButtonLabel gap={1} as="span">
              {selected.label} <FontAwesomeIcon icon={faChevronDown} />
            </ButtonLabel>
          </Button>
        )}
        onChange={e => {
          if (e.target) {
            const { value: selectedValue } = e.target as HTMLInputElement;
            if (selectedValue) {
              onChange(selectedValue);
            }
          }
        }}
      >
        {options.map(option => (
          <StyledDropdownOptionLabel
            key={option.value}
            className={classNames({
              selected: selected.value === option.value,
            })}
          >
            {option.label}
            <input
              type="radio"
              name="team-filter"
              value={option.value}
              defaultChecked={selected.value === option.value}
              className="sr-only"
            />
          </StyledDropdownOptionLabel>
        ))}
      </StyledDropdown>
      <StyledDivider />
    </>
  );
};
